// extracted by mini-css-extract-plugin
export default {"logotwo":"styles_logotwo__LiQgn","logo":"styles_logo__fjOxL"};